/**
 * @typedef {import('./Response').default} Response
 * @typedef {import('../../../../App/shared/HomeownerService/Homeowner').HomeownerAgent} HomeownerAgent
 */

import { homeownerService } from '../../../../service-container';
import { translate } from '../../../../App/Internationalization';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {boolean} [isGated]
 * @returns {Response}
 */
export default function useGetHomeownerAgent(isGated = false) {
	const [errorMessage, setErrorMessage] = useState('');
	const [isGettingData, setIsGettingData] = useState(!isGated);
	const [agent, setAgent] = useState(
		/** @type {HomeownerAgent | null} */ (null)
	);

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [isGated]);

	/** @returns {Promise<void>} */
	async function fetchData() {
		setIsGettingData(true);

		try {
			const response = await homeownerService.getHomeownerAgent();

			setAgent(response);
		} catch (error) {
			captureError(error);
			setErrorMessage(translate('global.error'));
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: agent,
			errorMessage,
			isGettingData,
		}),
		[agent, errorMessage, isGettingData]
	);
}
